
import { Vue, Component } from "vue-property-decorator";
import { Auth } from "aws-amplify";
import AuthCard from "@/components/auth/AuthCard.vue";
import UiButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import AuthFormLink from "@/components/auth/AuthFormLink.vue";
import JobBlissLogo from "@/components/icons/jobBlissLogo.vue";
import auth from "@/services/auth";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import { CHECK_YOUR_EMAIL } from "@/data/notificationMessagesTexts";

@Component({
  components: {
    AuthCard,
    JobBlissLogo,
    UiButton,
    FormGroup,
    AuthFormLink,
  },
})
export default class ForgotPassword extends Vue {
  loading: boolean = false;
  emailSent: boolean = false;
  email: string = "";

  async submit(): Promise<void> {
    this.loading = true;

    try {
      await auth.forgotPassword(this.email);
      this.emailSent = true;

      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(CHECK_YOUR_EMAIL)
      );
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    } finally {
      this.loading = false;
    }
  }
}
